import React, {type PropsWithChildren} from "react";
import "./Alert.scss";

export const Alert: React.FC<PropsWithChildren> = ({children}) => {
  return (
    <div className="alert alert-danger alert-box" role="alert" id="alert">
      <div className="alert-icon">
        <i className="fal fa-exclamation-circle"></i>
      </div>
      <div className="alert-content">{children}</div>
    </div>
  );
};
